







































































































































































































































import CTransitionExpand from '~/components/shared/configurable/expand/CTransitionExpand.vue'
import {
  defineComponent,
  defineVue3AsyncComponent,
  computed,
  ref
} from '~/utils/nuxt3-migration'
import { defineComponentTranslations } from '~/utils/i18n'
import { MessageStatus } from '~/models/messages/messages'
import SearchBucketService from '~/services/search-bucket/SearchBucketService'
import WantedPartsMakeModel from '~/components/car/wanted-parts/WantedPartsMakeModel.vue'
import ClassifiedSearchResultsRowActions from '~/components/car/classifieds/search/results/ClassifiedSearchResultsRowActions.vue'
import { ciClock } from '~/icons/source/regular/clock'
import { CategoryId } from '~/models/category/types'
import { ciEye } from '~/icons/source/solid/eye'
import { ciCog } from '~/icons/source/solid/cog'
import { ciAngleDown } from '~/icons/source/solid/angle-down'
import { ciEnvelope } from '~/icons/source/solid/envelope'
import { ciAngleRight } from '~/icons/source/regular/angle-right'
import { ciLocationPin } from '~/icons/source/regular/location-pin'
import { useClassifiedSearchResultRow } from '~/compositions/classified-search/useClassifiedSearchResultRow'
import { useDeps } from '~/compositions/dependency-container'
import { useRequestError } from '~/compositions/request-error'
import CClassifiedFavoriteButton from '~/components/shared/configurable/classified/favorite/CClassifiedFavoriteButton.vue'
import WantedBadge from '~/components/car/classifieds/badges/WantedBadge.vue'
import { ciCheck } from '~/icons/source/solid/check'
import { PropType } from 'vue'
import { ClassifiedSearchResultRow } from '~/models/search/types'

export default defineComponent({
  props: {
    classified: {
      type: Object as PropType<ClassifiedSearchResultRow>,
      required: true
    }
  },
  components: {
    WantedBadge,
    BackgroundJobsBadge: defineVue3AsyncComponent(() =>
      import(
        '~/components/car/classifieds/search/results/rows/main/partials/BackgroundJobs/BackgroundJobsBadge.vue'
      )
    ),
    PaidClassifiedInfo: defineVue3AsyncComponent(() =>
      import(
        '~/components/car/classifieds/search/results/rows/main/partials/PaidInfo/PaidClassifiedInfo.vue'
      )
    ),
    CTransitionExpand,
    WantedPartsMakeModel,
    CContactFormModal: defineVue3AsyncComponent(() =>
      import(
        '~/components/shared/configurable/contact-form-modal/CContactFormModal.vue'
      )
    ),
    ClassifiedSearchResultsRowActions,
    CClassifiedFavoriteButton
  },
  setup(props) {
    const {
      lastModifiedDate,
      href,
      rowBgClass,
      classifiedBackgroundJobs,
      showActions,
      onRowClick,
      getKeyFeatureIcon
    } = useClassifiedSearchResultRow(props.classified)
    const [searchBucketService] = useDeps(SearchBucketService)
    const handleRequestError = useRequestError()

    const actionsAreCollapsed = ref(false)
    const isLoading = ref(false)
    const isSeen = ref(props.classified.isSeen)
    const isContactFormModalVisible = ref(false)

    const messageButtonVariant = computed(() => {
      const statusToVariantMap = {
        [MessageStatus.HAS_UNREAD_MESSAGES]: 'orange',
        [MessageStatus.HAS_READ_MESSAGES]: 'primary'
      }
      return statusToVariantMap[props.classified.messageStatus] || 'neutral'
    })

    const hasNoMessages = computed(
      () => props.classified.messageStatus === MessageStatus.NO_MESSAGES
    )

    const logoType = computed(() =>
      props.classified.categoryIds?.includes(CategoryId.WANTED_PARTS_BIKES)
        ? 'bikes'
        : 'cars'
    )

    const shouldShowFooter = computed(
      () =>
        props.classified.address ||
        props.classified.addressLong ||
        props.classified.modified
    )

    const firstMakeModel = computed(
      () =>
        props.classified?.forMakemodels?.[0] || {
          make: { id: 0, name: '' },
          model: {
            name: ''
          }
        }
    )

    async function onSeenButtonClick() {
      isLoading.value = true

      try {
        if (isSeen.value) {
          await searchBucketService.removeSeenFromBucket(props.classified.id)
          isSeen.value = false
        } else {
          await searchBucketService.addToSeenBucket(props.classified.id)
          isSeen.value = true
        }
      } catch (error) {
        handleRequestError(error)
      } finally {
        isLoading.value = false
      }
    }

    return {
      ciAngleRight,
      ciEnvelope,
      ciEye,
      ciCog,
      ciAngleDown,
      ciClock,
      ciLocationPin,
      ciCheck,
      showActions,
      href,
      classifiedBackgroundJobs,
      isSeen,
      isLoading,
      lastModifiedDate,
      logoType,
      hasNoMessages,
      actionsAreCollapsed,
      messageButtonVariant,
      shouldShowFooter,
      firstMakeModel,
      isContactFormModalVisible,
      rowBgClass,
      onSeenButtonClick,
      onRowClick,
      getKeyFeatureIcon
    }
  },
  i18n: defineComponentTranslations({
    saw_it: {
      en: 'Saw it',
      el: 'Το είδα'
    }
  })
})
